export * from './IconTeam';
